export default Object.freeze({
	UserInteraction: 'user_interaction',
	UserInputStarted: 'user_input_started',
	UserInputCompleted: 'user_input_completed',
	SystemErrorMessage: 'system_error_message',
	SystemVisibleMessage: 'system_visible_message',
});
